import { render, staticRenderFns } from "./Lembur.vue?vue&type=template&id=999bc6fa"
import script from "./Lembur.vue?vue&type=script&lang=js"
export * from "./Lembur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports